import { useQuery } from '@tanstack/react-query';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';

/**
 * Produkt-Statistik Managed-DBs — Betreiber-Sicht, nur lesend. Gesamtzahl der
 * verwalteten Datenbanken und Tenants plus Aufschlüsselung nach Engine und
 * Status. M2M-Auth wie alle /v1/admin/*-Endpoints.
 */
const FIXTURE = {
  databases: 156,
  tenants: 71,
  byEngine: [
    { engine: 'postgres', n: 98 },
    { engine: 'mysql', n: 41 },
    { engine: 'redis', n: 17 },
  ],
  byStatus: [
    { status: 'running', n: 142 },
    { status: 'provisioning', n: 6 },
    { status: 'degraded', n: 5 },
    { status: 'stopped', n: 3 },
  ],
};

export function useManagedDbStats() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['product-stats-managed-db', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return FIXTURE; }
      return nexusFetch('/v1/admin/product-stats/managed-db');
    },
    refetchInterval: 60_000,
  });
}
